import React, { useRef } from "react";
import useInView from "../../hooks/useInView";
import "./ArtistImages.css";
import portrait1 from "../../assets/portraits/D8470D_PNG.png";


const ArtistSingleImages = () => {
  const Ref = useRef(null);

  const isVisible = useInView(Ref);

  return (
    <>
    <div className="artist-singleimages-container">
    <h1 className="about-heading">About Shri. Seattle Raman</h1>
      <img
        ref={Ref}
        src={portrait1}
        alt="Artist Portrait 1"
        className={`single-portrait center ${isVisible ? "fade-in" : ""}`}
      />
      
    </div>
    
    
    </>
    
  );
};

export default ArtistSingleImages;
